<template>
    <div>
        <a-row>
            <a-col :span="24" style="margin-bottom: 10px;border-bottom: 1px solid #f0f2f5;">
                <a-row type="flex" justify="start">
                    <a-col :span="20" :style="{textAlign: 'left',padding: '10px 0 0 20px'}">
                        <span style="font-size: 1.6em;">添加图片</span>
                    </a-col>
                    <a-col :span="4" :style="{textAlign: 'right', padding: '10px 20px 10px 0'}">
                        <router-link to="/admin/img">
                            <a-button type="primary">
                                返回列表
                            </a-button>
                        </router-link>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="16" :offset="4" :style="{padding: '10px 24px 24px 24px'}">
                <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                >
                    <a-form-model-item ref="title" label="图片标题" prop="title">
                        <a-input v-model="form.title"/>
                    </a-form-model-item>
                    <a-form-model-item label="所属网站" prop="website">
                        <a-select v-model="form.website" placeholder="请选择所属网站" @change="websiteChange">
                            <a-select-option v-for="item in website" :key="item.uuid" :value="item.uuid">
                                {{ item.title }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item label="图片标签" prop="tag">
                        <a-select v-model="form.tag" placeholder="请选择图片标签" @focus="checkWebsiteExist">
                            <a-select-option v-for="item in tag" :key="item.uuid" :value="item.uuid">
                                {{ item.title }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item ref="picOrder" label="图片顺序" prop="picOrder">
                        <a-input-number style="width: 100%" id="inputNumber" v-model="form.picOrder" :min="1" :max="100" />
                    </a-form-model-item>
                    <a-form-model-item ref="article" label="映射文章" prop="article">
                        <a-select
                            show-search
                            v-model="form.article"
                            placeholder="请选择要链接的文章"
                            style="width: 100%"
                            :default-active-first-option="false"
                            :show-arrow="false"
                            :filter-option="false"
                            :not-found-content="null"
                            @search="fetchArticle"
                            @change="articleHandleChange"
                        >
                            <a-select-option v-for="d in articleList" :key="d.uuid" :value="d.uuid">
                                {{ d.title }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item label="图片" style="text-align: left">
                        <a-upload
                            name="file"
                            :multiple="false"
                            :action="uploadHost"
                            :headers="headers"
                            :before-upload="picSignature"
                            :data="uploadData"
                            @change="handleChange"
                        >
                            <a-button>
                                <a-icon type="upload"/>
                                点击上传
                            </a-button>
                            <div style="font-size:14px;">图片建议尺寸：1920*1080</div>
                            <div>
                                <img v-if="form.url !== null && form.url!== undefined" :src=getPic(form.url) style="width: 100%;" />
                            </div>
                        </a-upload>
                    </a-form-model-item>

                    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                        <a-button v-if="$route.params.img === 'add'" type="primary" @click="onSubmit">
                            添加图片
                        </a-button>
                        <a-button v-else type="primary" @click="onSubmit">
                            保存
                        </a-button>
                        <a-button style="margin-left: 10px;" @click="resetForm">
                            重置
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </a-col>
        </a-row>
    </div>
</template>

<script>

export default {
    name: "ImgAdd",
    data() {
        return {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
            form: {
                title: '',
                website: undefined,
                tag: '',
                url: undefined,
                article: undefined
            },
            articleSearch: false,
            articleList: [],
            website: [],
            tag: [],
            rules: {
                title: [
                    {required: true, message: '图片标题必须输入', trigger: 'blur'},
                    {min: 2, max: 20, message: '图片标题在2-20个汉字长度范围', trigger: 'blur'},
                ],
                website: {required: true, message: '必须选择归属网站', trigger: 'change'},
                tag: {required: true, message: '必须选择图片标签', trigger: 'change'},

            },
            headers: {
                'x-oss-object-acl': 'public-read'
            },
            uploadHost: '',
            uploadData: {},
        };
    },
    methods: {
        getPic(pic) {
            return this.$host + '/admin/pic/read?pic=' + pic;
        },
        picSignature() {
            let that = this
            return this.$ajax.get(this.$host+"/admin/pic/uploadSig", {
                params: {}
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.uploadHost = 'http://' + result.data.host;
                    that.uploadData.key = result.data.path;
                    that.uploadData.policy = result.data.policy;
                    that.uploadData.OSSAccessKeyId = result.data.accessId;
                    that.uploadData.signature = result.data.signature;
                } else {
                    return Promise.reject();
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        handleChange(info) {
            if (info.file.status === 'done') {
                this.$message.success(`${info.file.name} 上传成功`);
                this.form.url = this.uploadData.key;
            } else if (info.file.status === 'error') {
                this.$message.error(`${info.file.name} 上传失败`);
            }
        },
        getWebsite() {
            let that = this;
            this.$ajax.get(this.$host+"/admin/website/listAll", {
                params: {}
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.website = result.data;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        websiteChange() {
            this.form.tag = null;
            this.getProCategory();
        },
        getProCategory() {
            this.checkWebsiteExist();
            let that = this;
            this.$ajax.get(this.$host+"/admin/albumTag/listByWebsite", {
                params: {
                    website: this.form.website
                }
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.tag = result.data;
                    if (that.tag.length > 0 && that.form.tag==null) {
                        that.form.tag = that.tag[0].uuid;
                    }
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        getArticle() {
            let that = this;
            this.$ajax.get(this.$host+"/admin/article/findTitle", {
                params: {
                    article: this.form.article
                }
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    if(result.data!==null){
                        that.articleList[0]={
                            uuid:result.data.uuid,
                            title:result.data.title
                        }
                    }
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        fetchArticle(value) {
            if(this.articleSearch){
                return;
            }
            console.log('fetching article', value);
            if(this.form.website===null || this.form.website===undefined){
                return;
            }
            if(value===""){
                return;
            }
            let that = this;
            let formData = new FormData();
            formData.set("title",value);
            formData.set("website",this.form.website);
            this.articleSearch = true;
            this.$ajax.post(this.$host+"/admin/article/search", formData).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.articleList = result.data;
                }
                that.articleSearch = false;
            }).catch(function (err) {
                console.log(err)
                that.articleSearch = false;
            });

        },
        articleHandleChange(value) {
            this.form.article = value;
        },
        checkWebsiteExist() {
            if (this.form.website === null || this.form.website === undefined) {
                this.$message.info("请先选择图片所属网站");
            }
        },
        addSuccess() {
            let that = this;
            let text = '添加';
            if (this.$route.params.img !== 'add') {
                text = '编辑';
            }
            this.$Modal.confirm({
                title: text + '图片成功',
                content: '已经成功' + text + '名为：' + this.form.title + '的图片，点击确定跳转到图片列表',
                okText: '好的',
                okType: 'danger',
                cancelText: '继续' + text,
                onOk() {
                    that.$router.push({path: "/admin/img"});
                },
                onCancel() {
                    that.resetForm();
                },
            });
        },
        addPro() {
            let that = this;
            this.$ajax.post(this.$host+"/admin/album/add", that.form).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.addSuccess();
                } else {
                    that.$message.warn(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        editPro() {
            let that = this;
            let p = this.form;
            p.uuid = this.$route.params.img;
            this.$ajax.post(this.$host+"/admin/album/update", p).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.addSuccess();
                } else {
                    that.$message.warn(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        onSubmit() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (this.form.url === undefined) {
                        this.$message.info("必须上传图片");
                        return false;
                    }
                    if (this.$route.params.img === 'add') {
                        this.addPro();
                    } else {
                        this.editPro();
                    }
                } else {
                    this.$message.info("填写内容不合法，请检查");
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        getBaseData() {
            let that = this;
            this.$ajax.get(this.$host+"/admin/album/details", {
                params: {
                    album: this.$route.params.img
                }
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.form = result.data;
                    that.getProCategory();
                    that.getArticle();
                } else {
                    that.$message.info(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        }
    },
    mounted() {
        this.getWebsite();
        if (this.$route.params.img !== 'add') {
            this.getBaseData();
        }
    }
}
</script>

<style scoped>

</style>